import { createApp, reactive } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { post, get, check } from './utils/request'
import i18n from '@/utils/locale'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { getMenu } from './assets/menu'
import { setCompanyId, getSpecified } from './utils/address'

const app = createApp(App)

// element-plus图片
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局变量
const globalData = reactive({
  // 公司Id
  companyId: 0,
  // 公司名称
  companyName: '',
  // 公司logo
  companyLogo: '',
  // 用户ID
  userId: 0,
  // 用户名称
  userName: '',
  // 用户头像
  userPhoto: '',
  // 角色
  userGroupId: 1,
  // 用户角色
  userGroup: '',
  // 基础权限开始时间
  authorizationStartTime: '',
  // 基础权限到期时间
  authorizationEndTime: '',
  // 模块权限
  modulePermission: [],
  // 功能权限详情
  functionPermission: [],
  // 是否控制刷新
  isRefreshing: false,
  // 当前激活的路径
  ativePath: '',
  // 当前激活的参数
  ativeParam: '',
  // 当前激活的名称
  ativeName: '',
  // 已显示的菜单路径
  showAtivePath: [],
  // 已显示的菜单参数
  showAtiveParam: [],
  // 已显示的菜单名称
  showAtiveName: [],
  // 菜单对应的路径(页面元素)
  homologousAtivePath: getMenu(),
  // 菜单栏是否收缩(页面元素)
  collapse: false,
  // 主题抽屉
  themeDrawer: false,
  // 左侧主题
  leftComponent: 'AsideDarkComponent',
  // 顶部主题
  topComponent: 'HeaderLightComponent',
  // 加载动画是否显示(页面元素)
  showLoading: false,
  // 加载动画触发次数(页面元素)
  loadingCount: 0,
  // 软件环境 prod-生产环境，loca-本地环境
  environment: window.options.environment,
  // 实时监控地址
  monitoringUrl: window.options.monitoringUrl
})
app.config.globalProperties.$globalData = globalData

// 关闭指定标签页 返回上一页
app.config.globalProperties.$closeTabs = function (path) {
  // 获取当前页的索引位置
  const index = globalData.showAtivePath.findIndex(item => item === globalData.ativePath)
  // 删除当前打开的链接和名称
  this.$globalData.showAtivePath.splice(index, 1)
  this.$globalData.showAtiveParam.splice(index, 1)
  this.$globalData.showAtiveName.splice(index, 1)
  if (path !== undefined && path !== '') {
    router.replace(path)
  } else {
    // 返回上一页
    router.back()
  }
}

// 封装的请求
app.config.globalProperties.$post = post
app.config.globalProperties.$get = get
app.config.globalProperties.$check = check
// 服务器地址
app.config.globalProperties.$serverUrl = window.options.serverUrl

// 封装获取文件地址
app.config.globalProperties.$setCompanyId = setCompanyId
app.config.globalProperties.$getSpecified = getSpecified

// 显示加载动画
app.config.globalProperties.$showLoading = function () {
  globalData.loadingCount += 1
  if (!globalData.showLoading) {
    globalData.showLoading = true
  }
}
// 隐藏加载动画
app.config.globalProperties.$hideLoading = function () {
  globalData.loadingCount -= 1
  if (globalData.loadingCount <= 0) {
    globalData.showLoading = false
  }
}

// 解决窗口放大缩小异常
window.ResizeObserver = class _NewResizeObserver extends ResizeObserver {
  constructor (callback) {
    super(() => window.requestAnimationFrame(() => callback.apply(this, arguments)))
  }
}

app.use(router)
app.use(i18n)
app.use(ElementPlus)
app.mount('#app')
